export const greeting = 'Hi, My name is';
export const myName = 'Priyanshu Kumar.';
export const intro =
	'I am a Full Stack Developer based in Dhanbad Jharkhand. I build things for web.';
